import * as React from 'react';
export const naverPaySvg = React.forwardRef(function naverPaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00DE5A',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm27.176 14.014-1.167 2.658-1.319-2.658h-1.015l1.87 3.688-.771 1.72h.985l2.401-5.41h-.984v.002Zm-4.064 4.109h-.964v-.384a1.88 1.88 0 0 1-1.27.467c-1.153 0-2.056-.938-2.056-2.138s.903-2.139 2.057-2.139c.503 0 .92.167 1.269.468v-.384h.964v4.11Zm-.852-2.055c0-.775-.54-1.364-1.259-1.364-.716 0-1.258.589-1.258 1.364 0 .775.54 1.363 1.258 1.363s1.259-.588 1.259-1.363Zm-8.231 3.354h1.006v-1.648c.34.28.743.432 1.227.432 1.154 0 2.057-.938 2.057-2.138s-.903-2.139-2.057-2.139c-.503 0-.921.167-1.27.468v-.384h-.963v5.41Zm2.11-4.716c.716 0 1.259.588 1.259 1.364 0 .775-.54 1.363-1.259 1.363-.716 0-1.259-.588-1.259-1.363 0-.776.54-1.364 1.259-1.364Zm-3.913 1.488a4.193 4.193 0 1 1-8.387 0 4.193 4.193 0 0 1 8.387 0Zm-3.492-1.97v2.109L7.27 14.224H6.061v3.942H7.33v-2.109l1.465 2.109h1.209v-3.942h-1.27Z',
      fill: '#000',
    }),
  );
});
naverPaySvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var naverPay = {
  category: 'brand',
  colorable: false,
  name: 'naverPay',
  svg: naverPaySvg,
};
